import React, { useState, useEffect } from "react";
import JeopardyCell from "./JeopardyCell";
import categories from "../data/questions";
import "../styles.css";

const JeopardyBoard = ({ onQuestionSelect, usedCells, onCellUsed }) => {
  const handleSelect = (categoryIdx, questionIdx, q) => {
    // Mark cell used through prop callback
    onCellUsed(categoryIdx, questionIdx);
    
    // Bubble up question for modal, scoring, etc.
    onQuestionSelect(q);
  };

  return (
    <div className="jeopardy-board fade-in">
      {categories.map((category, catIdx) => (
        <div key={catIdx}>
          <div className="category">{category.title}</div>
          {category.questions.map((q, qIdx) => {
            const key = `${catIdx}-${qIdx}`;
            const isUsed = Boolean(usedCells[key]);
            return (
              <JeopardyCell
                key={key}
                value={q.value}
                disabled={isUsed}
                onClick={() => !isUsed && handleSelect(catIdx, qIdx, q)}
              />
            );
          })}
        </div>
      ))}
    </div>
  );
};

export default JeopardyBoard;